import { render, staticRenderFns } from "./ThgChargingStationDetail.vue?vue&type=template&id=dfc08c80"
import script from "./ThgChargingStationDetail.vue?vue&type=script&lang=ts"
export * from "./ThgChargingStationDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports